import type { GetCauseAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetCauseAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetCauseAuditByIdArgs = {
  id: string;
};

export const useGetCauseAuditById = createQueryHook<
  UseGetCauseAuditByIdArgs,
  GetCauseAuditByIdResponseRow[],
  AuditLogQueryResult<
    'cause_audit',
    GetCauseAuditByIdResponseRow,
    'Description'
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCauseAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ cause_audit: data }),
  graphqlDocument: GetCauseAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
